import React from "react";
import LicenceModal from "./component";

const LicenceModalContainer = ({ isOpen, onToggle,onBuyLicence,togglePayment}) => {
  return <LicenceModal isOpen={isOpen} onToggle={onToggle} onBuyLicence= {onBuyLicence} togglePayment = {togglePayment} />;
};

export default LicenceModalContainer;
